<template>
  <div class="main-page" :class="theme || 'blue'" v-wechat-title="title">
    <div class="m-pc-page">
      <Header></Header>
      <Title></Title>
      <Content></Content>
      <Thumbs></Thumbs>
    </div>
    <div class="m-page-line" v-if="isShowFile"></div>
    <div class="m-pc-page" v-if="isShowFile">
      <File></File>
    </div>
    <div class="m-page-line" v-if="isShowComment"></div>
    <div class="m-pc-page page-bottom" v-if="isShowComment">
      <Comment></Comment>
      <CommentList></CommentList>
    </div>
    <div class="m-overall" v-if="isSetting"></div>
  </div>
</template>
<script>
//import Vue from "vue";
import Header from "../components/Header";
import Title from "../components/Title";
import Content from "../components/Content";
import Thumbs from "../components/Thumbs";
import File from "../components/File";
import Comment from "../components/Comment";
import CommentList from "../components/CommentList";
// import Pager from "../components/Pager";
import { URLS, $subscriber } from "fire-wind-water";
import service from "../services/article";
import { getSess, globalUserId, articleId } from "../common/sbase";
import { articleSettingInfo } from "../common/settingData";
// import { mixinsTemplate } from "../common/mixinsTemplate";
//  import $ from "jquery";

export default {
  name: "Article",
  data() {
    return {
      isShowFile: false,
      isShowComment: false,
      title: "",
      isSetting: false,
      theme: ""
      // browseCount:0,
      // likeCount:0,
      // isAllowedComment:0,//是否评论
    };
  },
  created() {
    if (URLS.getURL("isSetting")) {
      this.isSetting = true;
      this.isShowFile = true;
      this.isShowComment = true;
      $subscriber.emit("article-info", articleSettingInfo);
    } else {
      this.load();
    }

    $subscriber.subscribe("config-loaded", res => {
      let url = res.css.replaceUrl;
      this.theme = url.substr(url.lastIndexOf("/") + 1, url.length);
    });
  },
  methods: {
    load() {
      // const articleId = URLS.getURL("articleId");
      const tenantId = URLS.getURL("tenantId");
      // const ocode = URLS.getURL("ocode");
      const param = {
        articleId: articleId,
        tenantId: tenantId,
        isScroll: 1,
        withStat: 1,
        withTag: 1
      };
      //获取文章信息
      service.getArticle(param).subscribe(data => {
        this.title = data.content.title + "_内容管理__Smarket智营";
        let sess = getSess(data.content.schemaId);
        if (data.content.identity == 3 && sess == "") {
          const param = {
            formId: data.content.registerFormId,
            memberFormId: data.content.registerFormId,
            globalUserId: globalUserId,
            keyword: "",
            num: 999,
            schemaId: data.content.schemaId,
            start: 0,
            tenantId: data.content.tenantId,
            trackId: "0"
          };
          service.getNewForm(param).subscribe(data1 => {
            window.$sk.goto(
              `${data1.content.pcSourceUrl}&backUrl=${encodeURIComponent(window.location.href)}`);
          });
        } else {
          this.isShowFile =
            data.content.fileIds && data.content.fileIds.length > 0;
          this.isShowComment = data.content.isAllowedComment == 1;
          $subscriber.emit("article-info", data.content);
          // window.$sk.loading.hide();
          // let style = $('<link rel="stylesheet" type="text/css" href="./assets/css/red.css"/>');
          // $('head').append(style);
          //增加浏览量
          if (globalUserId) {
            let param = {
              articleId: articleId,
              sess: sess,
              globalUserId: globalUserId,
              openId: "",
              url: window.location.href,
              referenceUrl: document.referrer,
              equipment: {},
              pageTitle: data.content.title,
              weChatId: data.content.authorisedWeChatId,
              resolution: window.screen.width + "*" + window.screen.height
            };
            service.browse(param).subscribe(data => {
              data;
            });
          } else {
            $subscriber.subscribe("globalUserId-loaded", id => {
              let param = {
                articleId: articleId,
                sess: sess,
                globalUserId: id,
                openId: "",
                url: window.location.href,
                referenceUrl: document.referrer,
                equipment: {},
                pageTitle: data.content.title,
                weChatId: data.content.authorisedWeChatId,
                resolution: window.screen.width + "*" + window.screen.height
              };
              service.browse(param).subscribe(data => {
                data;
              });
            });
          }
          if (Number(data.content.useLinkUrl) === 1) {
            window.$sk.goto(data.content.linkUrl);
          } else {
            window.$sk.loading.hide(); //隐藏loading
          }
        }
      });
    }
  },
  components: {
    Header,
    Title,
    Content,
    Thumbs,
    File,
    Comment,
    CommentList
  }
};
</script>
